import { color } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Box } from "../../Box";
export const Pill = styled(Box) `
  border-radius: 12px;

  &.error {
    background-color: ${color.status.error.default};
  }

  &.warning {
    background-color: ${color.status.warning.default};
  }

  &.info {
    background-color: ${color.status.info.default};
  }

  &.success {
    background-color: ${color.status.success.default};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGlsbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1BpbGwvc3R5bGVkL1BpbGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQ3ZFLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFFaEMsTUFBTSxDQUFDLE1BQU0sSUFBSSxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTs7Ozt3QkFJUCxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxPQUFPOzs7O3dCQUkxQixLQUFLLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxPQUFPOzs7O3dCQUk1QixLQUFLLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxPQUFPOzs7O3dCQUl6QixLQUFLLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxPQUFPOztDQUVuRCxDQUFDIn0=